var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuitcaseIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.02303H14V2.91776C14 1.74934 13.11 0.8125 12 0.8125H8C6.89 0.8125 6 1.74934 6 2.91776V5.02303H2C0.89 5.02303 0.00999999 5.95987 0.00999999 7.12829L0 18.7072C0 19.8757 0.89 20.8125 2 20.8125H18C19.11 20.8125 20 19.8757 20 18.7072V7.12829C20 5.95987 19.11 5.02303 18 5.02303ZM12 5.02303H8V2.91776H12V5.02303Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcaseIconWhite);
export default __webpack_public_path__ + "static/media/suitcase-icon-white.885f181277ca3f641e5ebe55636f13cc.svg";
export { ForwardRef as ReactComponent };